import styled from "styled-components"

export const Container = styled.div`
  .MuiGrid-item {
    min-height: 180px;
  }
`
